package com.example.mystybag.appCore.model

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.DateTimeHelper
import com.example.mystybag.core.expected.logException
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.model.LinkModel
import com.example.mystybag.sharedmodels.mystyBag.responseModels.NotificationModel

data class NotificationsVisualModel(
    var date            : String                    = "",
    var time            : String                    = "",
    var message         : String                    = "",
    var type            : String                    = "",
    var shouldShowDate  : Boolean                   = true,
    var isEmail         : Boolean                   = false,
    var emailTexts      : MutableList<LinkModel>    = mutableListOf()
) {
    companion object {
        fun mapToVisualisationModel(notification: NotificationModel, previousModel: NotificationModel?) = NotificationsVisualModel().apply {
            date    = notification.date
            type    = notification.type
            message = notification.message

            if (message.contains(sharedString(SR.strings.support_email))) {
                isEmail = true
                message.indexOf(sharedString(SR.strings.support_email)).let { emailIndex ->
                    emailTexts.apply {
                        add(LinkModel(message.substring(0, emailIndex), ""))
                        add(LinkModel(sharedString(SR.strings.support_email), sharedString(SR.strings.support_email)))
                        add(LinkModel(message.substring(emailIndex + sharedString(SR.strings.support_email).length)))
                    }
                }
            }

            try {
                val dateStr = DateTimeHelper.formatNotEventDate(date)
                time        = dateStr?.substring(12, 20) ?: ""

                dateStr?.substring(0, 11)?.also { formattedDate ->
                    if (previousModel != null && date.startsWith(previousModel.date.substring(0, 10), true))
                        shouldShowDate = false
                    else
                        date = when {
                            DateTimeHelper.isToday(formattedDate)       -> sharedString(SR.strings.today)
                            DateTimeHelper.isYesterday(formattedDate)   -> sharedString(SR.strings.yesterday)
                            else                                        -> formattedDate
                        }
                }
            } catch (e: Exception) {
                logException(e)
            }
        }
    }
}